import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import MainLayout from "../../Layouts/Main_Layout";
import Header from "../../Header/header";
import HeaderMenu from "../../Header/header-menu";
import Isi from "../../ISI/Isi";
import IsiFrame from "../../ISI/Isi-frame";
import Footer from "../../Footer/Footer";

import './Sign-up.css'

import HCaptcha from '@hcaptcha/react-hcaptcha';

export default function SignUp() {
  const myRef = useRef(null)
  const [show, setShow] = useState(true);
  const [anonId, setAnonId] = useState("");
  const navigate = useNavigate();
  const url = process.env.REACT_APP_API_URL;
  const [language, setLanguage] = useState('')
  const [add, setAdd] = useState(false);
  const [captchaPass, setCaptchPass] = useState(false);
  const executeScroll = () => {
    myRef.current.scrollIntoView();
    setShow(true)
  }

  useEffect(() => {
    const calculateOffset = () => {
      const componentElement = myRef.current;
      if (myRef) {
        const offsetTop = componentElement.offsetTop;
        function handleScroll() {
          if (window.innerHeight + window.scrollY - 300 > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }

        window.addEventListener("scroll", handleScroll);


        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }
    };
    calculateOffset();
    window.addEventListener('resize', calculateOffset);

    const getCookieValue = (cookieName) => {
      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(cookieName + '='))
        ?.split('=')[1];

      return cookieValue;
    };
    const anonID = getCookieValue('Anon_ID');
    setAnonId(anonID)

    return () => {
      window.removeEventListener('resize', calculateOffset);
    };

  })

  const handleUserType = (inputName) => {

    document.getElementById('person1').classList.remove('active-class', 'error');
    document.getElementById('person2').classList.remove('active-class', 'error');
    if (inputName === 'patient') {
      document.getElementById('person1').classList.add('active-class');
    }
    else if (inputName === 'carepartner') {
      document.getElementById('person2').classList.add('active-class');
    }
    document.getElementById('userType').value = inputName;

  }

  const validateForm = (e) => {
    var sendForm = 1;
    var nameRegex = /^[a-zA-Z]+$/;
    var emailRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    var zipcodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
    var addressRegex = /^[a-zA-Z0-9\s,.'-]{3,}$/;
    var cityRegex = /^[a-zA-Z\s,.'-]{3,}$/;
    var lnameRegex = /^[a-zA-Z.\- ]+$/;
    var userType = document.getElementById('userType');
    var fname = document.getElementById('fname');
    var lname = document.getElementById('lname');
    var email = document.getElementById('email');
    var zipcode = document.getElementById('zipcode');
    var language1 = document.getElementById('language1');
    var language2 = document.getElementById('language2');
    var show_address = document.getElementById('show_address');
    if (userType.value !== 'patient' && userType.value !== 'carepartner') {
      document.getElementById('person1').classList.add('error');
      document.getElementById('person2').classList.add('error');
      sendForm = 0;
    }
    if (!fname.value.match(lnameRegex)) {
      sendForm = 0;
      fname.classList.add('error');
      // fname.focus();
    }
    else {
      fname.classList.remove('error');
    }
    if (!lname.value.match(lnameRegex)) {
      sendForm = 0;
      lname.classList.add('error');
    }
    else {
      lname.classList.remove('error');
    }

    if (!email.value.match(emailRegex)) {
      sendForm = 0;
      email.classList.add('error');
    }
    else {
      email.classList.remove('error');
    }
    if (!zipcode.value.match(zipcodeRegex)) {
      sendForm = 0;
      zipcode.classList.add('error');
    }
    else {
      zipcode.classList.remove('error');
    }

    if (!language1.checked && !language2.checked) {
      sendForm = 0;
      language1.classList.add('error');
      language2.classList.add('error');
    }
    else {
      language1.classList.remove('error');
      language2.classList.remove('error');

    }
    if (!captchaPass) {
      sendForm = 0;
    }

    if (show_address.checked) {
      var address1 = document.getElementById('address1');
      var address2 = document.getElementById('address1');
      var city = document.getElementById('city');
      var state = document.getElementById('state');
      var mailzip = document.getElementById('mailzip');

      if (!address1.value.match(addressRegex)) {
        sendForm = 0;
        address1.classList.add('error');
      }
      else {
        address1.classList.remove('error');
      }

      if (!city.value.match(cityRegex)) {
        sendForm = 0;
        city.classList.add('error');
      }
      else {
        city.classList.remove('error');
      }

      if (state.value === '') {
        sendForm = 0;
        state.classList.add('error');
      }
      else {
        state.classList.remove('error');
      }

      if (!mailzip.value.match(zipcodeRegex)) {
        sendForm = 0;
        mailzip.classList.add('error');
      }
      else {
        mailzip.classList.remove('error');
      }
    }
    return sendForm;
  }

  const submitFormFinal = (event) => {
    event.preventDefault();
    var status = validateForm();
    var userType = document.getElementById('userType');
    var fname = document.getElementById('fname');
    var lname = document.getElementById('lname');
    var email = document.getElementById('email');
    var zipcode = document.getElementById('zipcode');
    var address1 = document.getElementById('address1');
    var address2 = document.getElementById('address1');
    var city = document.getElementById('city');
    var state = document.getElementById('state');
    if(document.getElementById('mailzip').value.length > 0) {
      zipcode = document.getElementById('mailzip');    
    }
    var show_address = document.getElementById('show_address');
    const isPatient = userType.value === "patient" ? "Yes" : "No";
    const IsCarepartner  = userType.value === "carepartner" ? "Yes" : "No";
    const formData = {
      email: 'elvis.ruiz@merz.com',
      HCPEmail: email.value,
      Fname: fname.value,
      Lname: lname.value,
      Brand: "Inbrija",
      "Opt Source": "Inbrija.com",
      Address1: address1.value,
      Address2: address2.value,
      City: city.value,
      "Optin Event": add ? add : '',
      State: state.value,
      Zipcode: zipcode.value,
      qn_inbrijainterest_patient: "",
      qn_offperiodtype_patient: "",
      qn_sourcecode: "",
      IsPatient: isPatient,
      IsConsumer: IsCarepartner,
      Language: language,
      // visitor_id: anonId,
      visitor_id: "00000000-0000-0000-0000-000000000000",
      source_name: "inbrija_pwp_brand_signup",
      "Segmentation Type": '',
    };
    if (status) {
      const encodedCredentials = btoa("user:axis31.Kh23");
      fetch("https://2vvynl3neaqu47xsr3ewiuv6si0ibazg.lambda-url.us-east-1.on.aws/", {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Basic ${encodedCredentials}`,
        }
      }).then((data) => {
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
          window.gtag('event', 'ecrm_registration', {
            'event_category': 'form_submit',
            'event_label': 'submit_complete',
            'page_location': window.location.href
          });
        }
        navigate('/thank-you')
      })
    }
    else {
      document.getElementById('requiredError').classList.add('error');
      document.getElementById('requiredError1').classList.add('error');
    }
  }

  const showAddressFields = (e) => {
    if (document.getElementById('show_address').checked) {
      document.getElementById('address_field_box').classList.remove('d-none');
    }
    else {
      document.getElementById('address_field_box').classList.add('d-none');
    }
  }

  const handleVerificationSuccess = (token, ekey) => {
    setCaptchPass(true);
    return true;
  }
  return (
    <MainLayout>
      <div className="signup">
        <Helmet>
          <title>Sign Up for Updates | INBRIJA® (levodopa inhalation powder)</title>
          <meta property='og:title' content={`Sign Up for Updates | INBRIJA® (levodopa inhalation powder)`} />
          <meta property='og:description' content={`Fill out the form to receive updates and learn more about INBRIJA.`} />
          <meta property='og:site_name' content='INBRIJA.COM' />
          <meta property='og:type' content='website' />
          <meta name='description' content={`Fill out the form to receive updates and learn more about INBRIJA.`} />
          <meta property="og:image" content="https://inbrija.com/assets/images/Inbrija-OG-Image.jpg" />
          <meta property='og:url' content='https://inbrija.com/sign-up' />
          <meta property='og:image:alt' content='INBRIJA logo' />
        </Helmet>
        <Header />
        <HeaderMenu>
          <div className="hero-container">
            <div className="container signup-banner">
              <div className="signup-banner-heading">Sign up for updates</div>
              <div className="signup-banner-subheading">Fill out the form below to receive updates and to learn more about INBRIJA.</div>
            </div>
          </div>
        </HeaderMenu>
        <div className="brush-style"> </div>
        <div className="hero-container">
          <form className="signup-form" id="form-sign-up" onSubmit={submitFormFinal}>
            <div className="signup-form-heading">Which statement describes you?</div>
            <div className="signup-border"></div>
            <div className="person-text">I am a...</div>
            <div className="buttons">
              <button className="person-button" id="person1" onClick={() => handleUserType('patient')}>Person with Parkinson's</button>
              <button className="person-button" id="person2" onClick={() => handleUserType('carepartner')}>CarePartner, friend, or loved one</button>
              <input type="hidden" id="userType" />
            </div>
            <div className="signup-form-heading signup-margin">About you</div>
            <div className="signup-border"></div>
            <div className="form-fields-sign">
              <input className="form-field" id="fname" placeholder="First Name*" onChange={validateForm} />
              <input className="form-field" id="lname" placeholder="Last Name*" onChange={validateForm} />
              <input className="form-field" id="email" placeholder="Email Address*" onChange={validateForm} />
              <input className="form-field" id="zipcode" placeholder="ZIP Code*" onChange={validateForm} />
              <div className="required" id="requiredError1">*Required</div>
              <div className="languages" id="lang">
                <div className="pr-lang">Preferred language:</div>
                <div className="choice">
                  <input type="radio" name="language" id="language1" onChange={() => setLanguage('en')} />
                  <label htmlFor="language1" className="label">English</label>
                </div>
                <div className="choice">
                  <input type="radio" name="language" id="language2" onChange={() => setLanguage('es')} />
                  <label htmlFor="language2" className="label">Spanish</label>
                </div>
              </div>
            </div>
            <div className="signup-form-heading ">More ways to stay informed</div>
            <div className="signup-border"></div>
            <div className="choice mail-info">
              <input type="checkbox" id="show_address" onChange={() => { showAddressFields(); setAdd(!add) }} />
              <label className="label" htmlFor="show_address"> Check this box if you would also like INBRIJA information mailed to you.</label>
            </div>
            <div className="add-fields d-none" id="address_field_box">
              <input placeholder="Address Line 1*" id="address1" />
              <input placeholder="Address Line 2" />
              <div className="address">
                <div>
                  <input placeholder="City*" id="city" />
                </div>
                <div>
                  <select id="state" >
                    <option value="" >State*</option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="GU">Guam</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VI">Virgin Islands</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </select>
                </div>
              </div>
              <div className="zip-align">
                <input placeholder="ZIP Code*" id="mailzip" />
              </div>
              <div className="required" id="requiredError">*Required</div>
            </div>
            <div className="pt-5 text-left">
              <HCaptcha sitekey="d66a1a74-502f-426d-84b4-59a8c1826e8a" onVerify={(token,ekey) => handleVerificationSuccess(token, ekey)} />
            </div>
            <div className="info-content">
              <div className="required">The content on this site is being provided for informational purposes only.</div>
              <div className="required">By clicking submit, you are giving Merz Pharmaceuticals, LLC and the companies working with Merz permission to use your email address and other personal information to send you information. Read our <a href="https://www.merztherapeutics.com/us/privacy-policy/" className="required" rel="noreferrer" target="_blank">Privacy Policy</a>.</div>
              <button className="signup-page-button" id="ecrm_registration" type="submit">Submit</button>
            </div>
          </form>
        </div>
        <div className="signup-ques-banner">
          <div className="signup-ques">Have questions? <br /> Contact us at <span><a href="tel:1-833-462-7452" className="signup-ques-highlight">1-833-INBRIJA</a></span></div>
        </div>
        <div ref={myRef}><Isi /></div>
        {show ? <IsiFrame onClick={executeScroll} /> : ''}
        <Footer 
          partNum="3/26 US-INB-2400111v2"
          twitterCode="https://twitter.com/intent/tweet?text=Learn%20more%20about%20INBRIJA.%20INBRIJA%20is%20inhaled%20levodopa.%20Ask%20your%20doctor%20to%20learn%20more.%20https://www.inbrija.com"
          facebookLink="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2F&title=Learn%20more%20about%20INBRIJA&description=INBRIJA%20is%20inhaled%20levodopa.%20Ask%20your%20doctor%20to%20learn%20more." />
      </div>
    </MainLayout>
  )
}